import InfoModal from "../InfoModal";
import withContentfulTag from "../../utils/withContentfulTag";
import ReactMarkdown from "react-markdown";

const PriceCapInfoModal = ({ contentful, showInfoModal, setShowInfoModal }) => {
  if (!contentful) return null;

  return (
    <InfoModal
      open={showInfoModal}
      setOpen={setShowInfoModal}
      title={contentful?.title}
      buttonText={contentful?.primaryButtonText}
      fullWidthButton
      body={() => (
        <ReactMarkdown className="markdown">{contentful?.body}</ReactMarkdown>
      )}
    />
  );
};

export default withContentfulTag(
  PriceCapInfoModal,
  "switching_price_cap_tariff_info_modal",
);
